<ng-container>
    <div class="px-3 mt-3">
        <app-ice-hockey-rink
            qualifier="home"
            [selectedZoneId]="selectedZoneId"
            (selectedZoneIdChange)="onZoneChange($event)"
            tooltipStrategy="flip"
        />
    </div>

    <div class="px-3 mt-3">
        <select class="custom-select" [ngModel]="selectedZoneId" (ngModelChange)="onZoneChange($event)">
            <option [ngValue]="null">{{ 'web.shot-zone-select-all' | translate }}</option>
            @for (z of shotZones; track $index) {
            <option [ngValue]="z">
                {{ zoneI18nKey(z) | translate }}
            </option>
            }
        </select>
    </div>

    @if (tableRows.length) {
    <div class="table-responsive mt-3">
        <table class="table-scrollable__data__table flex-grow-1">
            <thead>
                <tr>
                    <th class="table-scrollable__table-th"></th>
                    <th class="table-scrollable__table-th"></th>
                    <th colspan="5" class="table-scrollable__table-th text-center">{{ 'web.total' | translate }}</th>
                    <th colspan="5" class="table-scrollable__table-th text-center">{{ 'web.average' | translate }}</th>
                </tr>
                <tr>
                    <th class="table-scrollable__table-th">{{ 'web.season' | translate }}</th>
                    <th class="table-scrollable__table-th">{{ 'web.subtournament' | translate }}</th>
                    <th class="table-scrollable__table-th text-center">
                        {{ 'web.shot-zone-ice-hockey-stat-goals' | translate }}
                    </th>
                    <th class="table-scrollable__table-th text-center">
                        {{ 'web.shot-zone-ice-hockey-stat-shots' | translate }}
                    </th>
                    <th class="table-scrollable__table-th text-center">
                        {{ 'web.shot-zone-ice-hockey-stat-missed_shots' | translate }}
                    </th>
                    <th class="table-scrollable__table-th text-center">
                        {{ 'web.shot-zone-ice-hockey-stat-blocked_att' | translate }}
                    </th>
                    <th class="table-scrollable__table-th text-center">
                        {{ 'web.shot-zone-ice-hockey-stat-shot_att' | translate }}
                    </th>
                    <th class="table-scrollable__table-th text-center">
                        {{ 'web.shot-zone-ice-hockey-stat-goals' | translate }}
                    </th>
                    <th class="table-scrollable__table-th text-center">
                        {{ 'web.shot-zone-ice-hockey-stat-shots' | translate }}
                    </th>
                    <th class="table-scrollable__table-th text-center">
                        {{ 'web.shot-zone-ice-hockey-stat-missed_shots' | translate }}
                    </th>
                    <th class="table-scrollable__table-th text-center">
                        {{ 'web.shot-zone-ice-hockey-stat-blocked_att' | translate }}
                    </th>
                    <th class="table-scrollable__table-th text-center">
                        {{ 'web.shot-zone-ice-hockey-stat-shot_att' | translate }}
                    </th>
                </tr>
            </thead>
            <tbody>
                @for (r of tableRows; track trackBySeasonRow($index, r)) {
                <tr>
                    <td class="table-scrollable__table-td">{{ r.seasonName }}</td>
                    <td class="table-scrollable__table-td">{{ r.subtournamentName }}</td>
                    <td class="table-scrollable__table-td text-center">{{ r.total.goals }}</td>
                    <td class="table-scrollable__table-td text-center">{{ r.total.shots }}</td>
                    <td class="table-scrollable__table-td text-center">{{ r.total.missed_shots }}</td>
                    <td class="table-scrollable__table-td text-center">{{ r.total.blocked_att }}</td>
                    <td class="table-scrollable__table-td text-center">{{ r.total.shot_att }}</td>
                    <td class="table-scrollable__table-td text-center">{{ r.average.goals }}</td>
                    <td class="table-scrollable__table-td text-center">{{ r.average.shots }}</td>
                    <td class="table-scrollable__table-td text-center">{{ r.average.missed_shots }}</td>
                    <td class="table-scrollable__table-td text-center">{{ r.average.blocked_att }}</td>
                    <td class="table-scrollable__table-td text-center">{{ r.average.shot_att }}</td>
                </tr>
                }
            </tbody>
        </table>
    </div>
    } @if (!tableRows.length) {
    <div class="text-muted small mt-3 pb-3 text-center">
        {{ 'web.shot-zones.no-data' | translate }}
    </div>
    }
</ng-container>
